import { render, staticRenderFns } from "./newRebateDealList.vue?vue&type=template&id=30e70d24"
import script from "./newRebateDealList.vue?vue&type=script&lang=js"
export * from "./newRebateDealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports